export default "__VITE_ASSET__t0_xAETWdch1hivv_wzSmA__"